export function wpSearch(){
    const container = document.querySelector('.search');

    if(!container) return false;

    let form = container.querySelector('form');

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        if(e.target.querySelector('[name="search"]').value.length === 0){
            return false;
        }

        let result_container = container.querySelector('.search-results'),
            formData = new FormData(e.target);

        formData.append('action', 'get_search_result');
        formData.append('_wpnonce', ajax_object.wp_nonce);

        result_container.innerHTML = "";

        let request = new XMLHttpRequest(),
            method = 'POST',
            url = ajax_object.ajax_url;

        request.open(method, url, true);
        request.send(formData);

        request.onerror = () => {
            console.log('ERROR: ' + this.response);
        }

        request.onload = function(){
            let response = JSON.parse(this.response).data
            response.posts.forEach((post) => {
                result_container.innerHTML += post;
            })
        }
    });

}